import { Stack } from '@mantine/core';
import { DialogSize } from '../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { useMyForm } from '../../../../../react-commons/hooks/useMyForm';
import { ContentSectionContentType } from '../../../resource/enumerations/ContentSectionContentType';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import {
    ContentSectionContentMutationResourceSchema,
    ContentSectionContentPropertyValidation,
    defaultContentSectionContentResource,
    useContentSectionContentActions,
} from '../../../resource/resources/artifacts/content/contentSectionContentResource';
import { PropertyInputs } from '../../reusable-components/base/property-bases/PropertyInputs';
import { EditChildBaseDialog } from '../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../util/utilFunctions';
import { ContentSectionContentContent } from './ContentSectionContentContent';

export const ContentSectionContentCreationDialog = ({
    onClose,
    parentId,
    versionId,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    versionId: string;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const contentSectionContentActions = useContentSectionContentActions();
    const addContentSectionContent = contentSectionContentActions.useAddResourceToIndex();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ContentSectionContentMutationResourceSchema,
        defaultValues: defaultContentSectionContentResource,
        submitHandler: async (data) => {
            await addContentSectionContent.mutateAsync(
                {
                    resource: data,
                    parentId,
                    index: null,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Section Content'}
            resourceType={ResourceType.CONTENT_SECTION_CONTENT}
            dialogSize={DialogSize.MEDIUM_LARGE}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <Stack>
                    <PropertyInputs.Enum
                        nullable={false}
                        enumType={ContentSectionContentType}
                        name={formNames.type}
                        propertyValidationInformation={{
                            propertyIdentifier: ContentSectionContentPropertyValidation.TYPE,
                            resourceType: ResourceType.CONTENT_SECTION_CONTENT,
                            resourceId: null,
                        }}
                        control={form.control}
                        typeFilter={(value) =>
                            value !== ContentSectionContentType.MARKDOWN &&
                            value !== ContentSectionContentType.PLAIN_TEXT
                        }
                        readOnly={false}
                    />
                    <ContentSectionContentContent
                        id={undefined}
                        versionId={versionId}
                        form={form}
                        formNames={formNames}
                        readOnly={false}
                    />
                </Stack>
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
